import React from "react";
import { ScrollView } from "react-native";
import GroupInfoCard from "./sidebar/group-info-card";
import LatestGroupsCard from "./sidebar/suggested-groups";
import { GroupDetailData, GroupListItem } from "@/src/models/group.model";

type GroupInfoSidebarProps = Readonly<{
  group?: GroupDetailData;
  latestGroups: GroupListItem[];
  onSelectGroup?: (id: string) => void;
  isAdmin?: boolean;
}>;

const GroupInfoSidebar = ({
  group,
  latestGroups,
  onSelectGroup,
  isAdmin,
}: GroupInfoSidebarProps) => {
  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      contentContainerStyle={{ gap: 12, paddingBottom: 16 }}
    >
      {group && <GroupInfoCard group={group} isAdmin={isAdmin} />}
      <LatestGroupsCard latestGroups={latestGroups} onSelect={onSelectGroup} />
    </ScrollView>
  );
};

export default GroupInfoSidebar;
